<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver">
            <i class="fa fa-chevron-left"></i></button>
        
        <button *ngIf="!visibilitySpinnerEnvio && !envioNotAllowed" class="btn btn-outline-success" type="button" [disabled]="envioNotAllowed || formInvalid" (click)="onClickEnvio()" title="Enviar Solicitud">
            <i class="fa fa-paper-plane-o"></i> Enviar</button>

        <button *ngIf="visibilitySpinnerEnvio" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Enviando
        </button>

        <div *ngIf="solicitudCam && !esPeriodoVigente && solicitudCam?.PeriodoPresentacionVigente === false" class="ms-1 nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Periodo no vigente</label>
        </div>
        <div *ngIf="solicitudCam && solicitudCam?.PeriodoPresentacionVigente === false" class="ms-1 nota-info warning">
            <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Solicitud fuera de plazo de Presentación</label>
        </div>
        <ng-container *ngIf="campaniaEspecifica && documentosSolicitudCam && campaniaEspecifica?.AdjuntarDocumentacion">
            <div *ngIf="getDocumentosObligatoriosSinAdjuntar() > 0" class="nota-info warning mb-1">
                <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Falta por adjuntar {{ getDocumentosObligatoriosSinAdjuntar() }} documento(s) obligatorio(s).</label>
            </div>
        </ng-container>
        <ng-container *ngIf="solicitudCam && !solicitudCam?.HasRecintosPIAED">
            <div class="nota-info warning ms-1">
                <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Falta incluir al menos {{ title }}</label>
            </div>
        </ng-container>
    </form>
</nav>

<div class="container-fluid container-list">
    <app-solicitud-cam-envio-form *ngIf="solicitudCam" [solicitudCam]="solicitudCam" [formGroup]="formGroup" [almacenes]="almacenes" [almacenObligatorio]="almacenObligatorio"></app-solicitud-cam-envio-form>

    <app-solicitud-cam-envio-errores *ngIf="showErrors" [IdTipoSolicitudCam]="solicitudCam?.IdTipoSolicitudCam" [recintosPIA]="erroresRecintosPIAIds"></app-solicitud-cam-envio-errores>
</div>
